import React, { createContext, useContext } from 'react';
import { FetchPendingSsnRecords } from '../../application/use-cases/FetchPendingSsnRecords';
import { ApiPendingSsnRepository } from '../repositories/ApiPendingSsnRepository';
import { useHttpClientCore } from '@/shared';
import { ArchiveI9UseCase } from '@/shared/application/use-cases/ArchiveI9UseCase';
import { ApiArchiveI9Repository } from '@/shared/infra/repositories/ApiArchiveI9Repository';

interface IPendingSsnDIContext {
  pendingSsnUseCase: FetchPendingSsnRecords;
  archiveI9UseCase: ArchiveI9UseCase;
}

const PendingSsnDIContext = createContext<IPendingSsnDIContext | undefined>(undefined);

export const PendingSsnDIProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const httpClient = useHttpClientCore();
  const repository = new ApiPendingSsnRepository(httpClient);
  const pendingSsnUseCase = new FetchPendingSsnRecords(repository);
  const archiveI9UseCase = new ArchiveI9UseCase(new ApiArchiveI9Repository(httpClient));

  return (
    <PendingSsnDIContext.Provider value={{ pendingSsnUseCase, archiveI9UseCase }}>
      {children}
    </PendingSsnDIContext.Provider>
  );
};

export function usePendingSsnDIContext() {
  const ctx = useContext(PendingSsnDIContext);
  if (!ctx) throw new Error('usePendingSsnDIContext must be used within PendingSsnDIProvider');
  return ctx;
}
